import ThermoformingForm from "./ThermoformingForm";

const registry = {
  // Map step IDs to components if known
  10: ThermoformingForm,
};

export function getStepComponent(stepId, stepDsc) {
  if (registry[stepId]) return registry[stepId];
  
  const dscLower = (stepDsc || "").toLowerCase();
  if (dscLower.includes("thermoform") || dscLower.includes("termoform")) {
    return ThermoformingForm;
  }
  
  return null;
}
